import { defineStore } from "pinia";

import orderInvoiceItemsApi from "@/services/api/orderInvoiceItemsApi";

import { getCompanyId } from "@/utils/userUtils";

export const useOrderInvoiceItemStore = defineStore(
  "orderInvoiceItemStore",
  {
    state: () => ({
      items: {},
      companyId: getCompanyId(),
      isLoading: false,
      error: null,
    }),

    actions: {
      async getItemsRequest(orderId, invoiceId, params = {}) {
        try {
          const response = await orderInvoiceItemsApi.index(
            this.companyId,
            orderId,
            invoiceId,
            params
          );
          const items = response.data.result || response.data || [];
          this.items = { ...this.items, [invoiceId]: items };
        } catch (error) {
          this.error = error;
          console.error("Ошибка при получении позиций счета:", error);
        }
      },

      async showItem(orderId, invoiceId, id) {
        try {
          const response = await orderInvoiceItemsApi.show(
            this.companyId,
            orderId,
            invoiceId,
            id
          );
          return response.data.result || response.data || {};
        } catch (error) {
          this.error = error;
          console.error("Ошибка при получении позиции счета:", error);
        }
      },

      async createItem(orderId, invoiceId, payload) {
        this.isLoading = true;
        try {
          await orderInvoiceItemsApi.create(
            this.companyId,
            orderId,
            invoiceId,
            payload
          );
          await this.getItemsRequest(orderId, invoiceId);
        } catch (error) {
          console.error("Ошибка при создании позиции счета:", error);
          throw error;
        } finally {
          this.isLoading = false;
        }
      },

      async updateItem(orderId, invoiceId, id, payload) {
        this.isLoading = true;
        try {
          await orderInvoiceItemsApi.update(
            this.companyId,
            orderId,
            invoiceId,
            id,
            payload
          );
          await this.getItemsRequest(orderId, invoiceId);
        } catch (error) {
          console.error(
            "Ошибка при обновлении позиции счета:",
            error
          );
          throw error;
        } finally {
          this.isLoading = false;
        }
      },

      async deleteItem(orderId, invoiceId, id) {
        this.isLoading = true;
        try {
          await orderInvoiceItemsApi.delete(
            this.companyId,
            orderId,
            invoiceId,
            id
          );
          await this.getItemsRequest(orderId, invoiceId);
        } catch (error) {
          console.error("Ошибка при удалении позиции счета:", error);
          throw error;
        } finally {
          this.isLoading = false;
        }
      },
    },
  }
);
